import { Box } from '@mui/material';
import { type SvgIconComponent } from '@mui/icons-material';
import HelperIconWithTooltip from 'src/shared/components/HelperIconWithTooltip';
import { IconWrapper, LabelWrapper, AmountWrapper } from './styles';

export enum SaldoItemStatus {
  PRIMARY = 'primary',
  WARNING = 'warning',
  DANGER = 'error'
}

export const saldoItemStatusToColor = {
  [SaldoItemStatus.PRIMARY]: '#3859E3',
  [SaldoItemStatus.WARNING]: '#EE7B15',
  [SaldoItemStatus.DANGER]: '#D10E0C'
};

type SaldoItemProps = {
  label: string;
  saldo: string;
  Icon: SvgIconComponent;
  status?: SaldoItemStatus;
  tooltipProps?: {
    title: string;
  };
};

export const SaldoItem = ({ label, saldo, Icon, status = SaldoItemStatus.PRIMARY, tooltipProps }: SaldoItemProps) => {
  return (
    <Box display="flex" gap="16px" mb={2} mt={2}>
      <Box>
        <IconWrapper status={status}>
          <Icon
            sx={{
              width: '1.5rem',
              height: '1.5rem',
              'max-width': '28px',
              'max-height': '28px',
              color: saldoItemStatusToColor[status]
            }}
          />
        </IconWrapper>
      </Box>
      <Box display="flex" flexDirection="column" justifyContent="space-evenly">
        <Box display="flex" alignItems="center" gap="4px">
          <LabelWrapper>{label}</LabelWrapper>
          {tooltipProps && <HelperIconWithTooltip {...tooltipProps} />}
        </Box>
        <Box>
          <AmountWrapper>{saldo}</AmountWrapper>
        </Box>
      </Box>
    </Box>
  );
};
